'use server'
// РУКА 1. Действия формы входа — их вызывает LoginForm (или своя форма Ло / Имы на тех же полях).
// Поля формы: intent = send | confirm, phone, code, redirectTo.
import { AuthError } from 'next-auth'
import { signIn, signOut } from '../auth'
import { issueCode, LoginError } from './codes'

export interface LoginState {
  step: 'phone' | 'code'
  phone?: string // +7XXXXXXXXXX, на который ушёл код
  sentAt?: number // когда ушёл код — для «Отправить снова через …»
  shownCode?: string // только тестовый сайт и не сотрудник: код прямо в форме (codeOnScreen, Д-8)
  error?: string
}

export async function loginAction(prev: LoginState, form: FormData): Promise<LoginState> {
  const phone = String(form.get('phone') ?? '')

  if (form.get('intent') === 'confirm') {
    try {
      await signIn('credentials', { phone, code: String(form.get('code') ?? ''), redirectTo: String(form.get('redirectTo') || '/') })
      return prev
    } catch (e) {
      // Неверный код — AuthError. Переход после успешного входа — тоже «исключение», его пробрасываем дальше.
      if (e instanceof AuthError) return { ...prev, step: 'code', error: 'Код не подошёл или устарел. Проверьте или запросите новый.' }
      throw e
    }
  }

  try {
    const { phone: normalized, shownCode } = await issueCode(phone)
    return { step: 'code', phone: normalized, sentAt: Date.now(), shownCode }
  } catch (e) {
    if (e instanceof LoginError) return { ...prev, error: e.message }
    throw e
  }
}

export async function logoutAction(form: FormData) {
  await signOut({ redirectTo: String(form.get('redirectTo') || '/') })
}
